import type * as localForage from 'localforage';

enum StorageManagerDriver {
  INDEXEDDB = 'asyncStorage',
  LOCALSTORAGE = 'localStorageWrapper',
  WEBSQL = 'webSQLStorage',
}

type OverrideOriginLocalForageParams<TData> = {
  clear(callback?: (err: Error) => void): Promise<void>;

  getItem<TKey extends keyof TData>(
    key: TKey,
    callback?: (err: Error, value: TData[TKey] | null) => void,
  ): Promise<TData[TKey] | null>;

  iterate<TKey extends keyof TData>(
    iteratee: (value: TData[TKey], key: TKey, iterationNumber: number) => [TKey, TData[TKey]],
    callback?: (err: Error, result: [TKey, TData[TKey]]) => void,
  ): Promise<[TKey, TData[TKey]]>;

  key(keyIndex: number, callback?: (err: Error, key: keyof TData) => void): Promise<keyof TData>;

  keys(callback?: (err: Error, keys: keyof TData[]) => void): Promise<keyof TData[]>;

  length(callback?: (err: Error, numberOfKeys: number) => void): Promise<number>;

  removeItem(key: keyof TData, callback?: (err: Error) => void): Promise<void>;

  setItem<TKey extends keyof TData>(
    key: TKey,
    value: TData[TKey],
    callback?: (err: Error, value: TData[TKey]) => void,
  ): Promise<TData[TKey]>;
};

type LocalForageInstance<TData> = OverrideOriginLocalForageParams<TData> &
  Omit<typeof localForage, keyof OverrideOriginLocalForageParams<TData>>;

type StorageManagerResParams<TData> = LocalForageInstance<TData>;

export type { StorageManagerResParams };
export { StorageManagerDriver };
